import { graphql } from "@/gql";

export const issueContactCreditMutation = graphql(`
  mutation IssueContactCredit($input: IssueContactCreditInput!) {
    issueContactCredit(input: $input) {
      id
    }
  }
`);

export const reverseContactCreditMutation = graphql(`
  mutation ReverseContactCredit($id: ID!, $description: String) {
    reverseContactCredit(id: $id, description: $description) {
      id
    }
  }
`);
